module.exports = __webpack_public_path__ + "img/florian-olivo-4hbJ-eymZ1o-unsplash.89e99f5f.jpg";